<template>
  <Navbar :title="$t('message.garage.myGarage')" />
  <div class="my-garage">
    <template v-if="infoStr">
      <div class="car-img">
        <van-icon class="car-menu-icon" name="weapp-nav" @click="showMenu = true" />
        <van-image class="car-image-ele" width="60%" :src="vehicleInfo.image" />
      </div>
      <div class="confirm-vehicle">
        <div class="vehicle-desc">
          <span class="mr10">{{ vehicleInfo.year }}</span>
          <span class="mr10">{{ vehicleInfo.make }}</span>
          <span class="mr10">{{ vehicleInfo.model }}</span>
        </div>
        <template v-if="vehicleInfo.type === 1">
          <div class="vehicle-info">
            <div class="vehicle-item">
              <span class="mr10">{{ vehicleInfo.trim }}</span>
            </div>
          </div>
          <div class="vehicle-info">
            <div class="vehicle-item">
              <span class="mr10">{{ vehicleInfo.engine }}</span>
            </div>
          </div>
        </template>
        <template v-if="vehicleInfo.type === 2">
          <div class="vehicle-info">
            <div class="vehicle-item">
              <span class="mr10">{{ vehicleInfo.submodel }}</span>
            </div>
          </div>
        </template>
      </div>
      <div class="btn-row">
        <van-button type="primary" size="large" @click="changeVehicle">
          {{ $t('message.garage.changeVehicle') }}
        </van-button>
      </div>
      <div class="search-form-garage">
        <div class="font-weight-600 font-size-16 mt-10 mb-10">
          {{ $t('message.garage.searchForThatFit') }}
        </div>
        <div class="mb10">
          <van-checkbox :model-value="true">
            <div class="checkbox-desc">
              {{ $t('message.garage.fitYour', { year: vehicleInfo.year, make: vehicleInfo.make }) }}
            </div>
          </van-checkbox>
        </div>
        <div class="search-input-box">
          <input class="search-input" type="text" placeholder="a product, brand, or keyword" />
          <div name="btn_garage_search" v-track-click @click="handleSearch">
            <van-icon class="search-icon" name="search"  />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="title">{{ $t('message.garage.guideStatement') }}</div>
      <div class="title-desc">{{ $t('message.garage.guideDesc') }}</div>
      <div class="btn-row">
        <van-button name="btn_add_vehicle" v-track-click type="primary" size="large" @click="handlAddVehicle">
          {{ $t('message.garage.addVehicle') }}
        </van-button>
      </div>
    </template>
    <van-popup
      v-model:show="showMenu"
      position="bottom"
      custom-style="height: 20%"
      @click="showMenu = false"
    >
      <div class="popup-content">
        <div class="button-group">
          <van-button type="primary" block @click="handleDelete" size="large">
            {{ $t('message.garage.deleteVehicle') }}
          </van-button>
          <van-button name="btn_add_vehicle" v-track-click type="default" block @click="handleAddVehicle" size="large">
            {{ $t('message.garage.addANewVehicle') }}
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import Navbar from '@/components/navbar/navbar.vue'
import { useGarageStore } from '@/store/garage'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const garageStore = useGarageStore()
const vehicleInfo = computed(() => garageStore.favoriteCar)
const infoStr = computed(() => {
  return `${vehicleInfo.value.year || ''} ${vehicleInfo.value.make || ''} ${vehicleInfo.value.model || ''} ${vehicleInfo.value.trim || ''} ${vehicleInfo.value.engine || ''}`.trim()
})
const showMenu = ref(false)

const changeVehicle = () => {
  router.push('/selectGarageVehicle')
}

const handlAddVehicle = () => {
  router.push('/vehiceltype')
}
const handleDelete = async () => {
  const { favoriteCar, updateSelectedCar } = garageStore
  updateSelectedCar(favoriteCar)
  router.push('/deleteVehicle')
}
const handleAddVehicle = () => {
  router.push('/vehiceltype')
}

const handleSearch = () => {}

onMounted(() => {
  garageStore.getGarageCarList({})
})

</script>
<style scoped lang="scss">
.garage {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.car-img {
  text-align: center;
  display: flex;
  justify-content: center;
  position: relative;
  .car-menu-icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.car-header {
  text-align: right;
  .popup-content {
    padding: 16px;
  }

  .button-group {
    margin-top: 16px;
  }

  .button-group .van-button {
    margin-bottom: 8px;
  }
}
.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}
.title-desc {
  font-size: 16px;
  margin-bottom: 20px;
}
.my-garage {
  padding: 20px;
  padding-top: 0;
}
.btn-row {
  text-align: center;
}
.checkbox-desc {
  font-size: 14px;
  color: #666;
}
.search-input-box {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .search-input {
    border: none;
    flex: 1;
    outline: none;
    padding: 0 10px;
    font-size: 16px;
  }
  .search-icon {
    font-size: 20px;
  }
}

.confirm-vehicle {
  padding: 0 10px;
  .vehicle-desc {
    font-size: 18px;
    color: #111;
    font-weight: bold;
  }
  .vehicle-info {
    font-size: 16px;
    color: #666;
  }
}
</style>
